import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../../authConfig';

import paginate from 'jw-paginate';

import {
  DetailsListLayoutMode,
  ShimmeredDetailsList,
  Selection,
  SelectionMode,
  Icon,
  Calendar,
  DateRangeType,
  Spinner,
  SpinnerSize,
  SearchBox,
  CommandBar,
  Stack,
  PrimaryButton,
  DefaultButton,
  TextField,
  ContextualMenu,
  CheckboxVisibility,
  Dialog,
  DialogType,
  DialogFooter,
} from '@fluentui/react';

// import { Pagination } from '@uifabric/experiments/lib/Pagination';
import { Pagination } from '@fluentui/react-experiments/lib/Pagination';

const API_URL = process.env.REACT_APP_API_URL;

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  background: '#FAF9F8',
};

const Stripe = (props) => {
  const location = useLocation();
  const state = location.state;
  const access_token = state.access_token;
  // const refresh_token = state.refresh_token;

  const history = useHistory();

  const { t, i18n } = useTranslation();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [items, setItems] = useState([]);
  const [loadDataComplete, setLoadDataComplete] = useState(false);
  const [getNewDocuments, setGetNewDocuments] = useState(true);
  const [pageData, setPageData] = useState({});
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(sessionStorage.getItem('stripe-currentPage') * 1 || 1);
  const [documents, setDocuments] = useState([]);

  const [allDocs, setAllDocs] = useState([]);
  //CommandBars Items
  const [documentType, setDocumentType] = useState(
    (sessionStorage.getItem('stripe-documentType-key') && {
      key: sessionStorage.getItem('stripe-documentType-key'),
      text: sessionStorage.getItem('stripe-documentType-text'),
    }) || {
      key: 'paid',
      text: 'PAID',
    }
  );

  const [company, setCompany] = useState('');
  const [search, setSearch] = useState('');

  const percentVat = 7;
  const zeroVat = 0;
  // const nonVat = -1;

  const percentVatText = '7%';
  const zeroVatText = '0%';
  // const nonVatText = '-'

  const dateType = { key: 'document', text: 'วันที่บนเอกสาร' };

  const [isLoading, setIsLoading] = useState(false);

  const [registerVat, setRegisterVat] = useState(true);

  const isCompactMode = false;

  const [isCreateDocument, setIsCreateDocument] = useState(false);
  const [isCreateDocumentComplete, setIsCreateDocumentComplete] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const [selection] = useState(
    new Selection({
      onSelectionChanged: () => {
        console.log('isCreateDocument: ', isCreateDocument);
        console.log('isCreateDocumentComplete: ', isCreateDocumentComplete);
        let _selectedItems = selection.getSelection();

        setSelectedItems(_selectedItems);
      },
    })
  );

  const [dialogConfirm, setDialogConfirm] = useState({
    isClick: false,
    header: '',
    message: '',
    onConfirm: null,
    onCancel: null,
  });

  const [createdBy, setCreatedBy] = useState('');

  const [primarySort, setPrimarySort] = useState(sessionStorage.getItem('stripe-primarySort') || 'documentDate');
  const [isSortedDescendingDocumentDate, setIsSortedDescendingDocumentDate] = useState(() => {
    if (sessionStorage.getItem('stripe-sort-documentDate') === 'false') {
      return false;
    } else {
      return true;
    }
  });
  const [isSortedDescendingNumber, setIsSortedDescendingNumber] = useState(() => {
    if (sessionStorage.getItem('stripe-sort-number')) {
      if (sessionStorage.getItem('stripe-sort-number') === 'true') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });
  const [isSortedDescendingCustomerName, setIsSortedDescendingCustomerName] = useState(() => {
    if (sessionStorage.getItem('stripe-sort-customerName')) {
      if (sessionStorage.getItem('stripe-sort-customerName') === 'true') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });
  const [isSortedDescendingVatTotal, setIsSortedDescendingVatTotal] = useState(() => {
    if (sessionStorage.getItem('stripe-sort-vatTotal')) {
      if (sessionStorage.getItem('stripe-sort-vatTotal') === 'true') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });
  const [isSortedDescendingGrandTotal, setIsSortedDescendingGrandTotal] = useState(() => {
    if (sessionStorage.getItem('stripe-sort-grandTotal')) {
      if (sessionStorage.getItem('stripe-sort-grandTotal') === 'true') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  const DayPickerStrings = {
    months: [
      t('stripe.months01'),
      t('stripe.months02'),
      t('stripe.months03'),
      t('stripe.months04'),
      t('stripe.months05'),
      t('stripe.months06'),
      t('stripe.months07'),
      t('stripe.months08'),
      t('stripe.months09'),
      t('stripe.months10'),
      t('stripe.months11'),
      t('stripe.months12'),
    ],

    shortMonths: [
      t('stripe.shortMonths01'),
      t('stripe.shortMonths02'),
      t('stripe.shortMonths03'),
      t('stripe.shortMonths04'),
      t('stripe.shortMonths05'),
      t('stripe.shortMonths06'),
      t('stripe.shortMonths07'),
      t('stripe.shortMonths08'),
      t('stripe.shortMonths09'),
      t('stripe.shortMonths10'),
      t('stripe.shortMonths11'),
      t('stripe.shortMonths12'),
    ],

    days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],

    shortDays: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],

    goToToday: t('stripe.goToToday'),
    prevMonthAriaLabel: 'ไปเดือนที่แล้ว',
    nextMonthAriaLabel: 'ไปเดือนถัดไป',
    prevYearAriaLabel: 'ไปปีที่แล้ว',
    nextYearAriaLabel: 'ไปปีถัดไป',
    closeButtonAriaLabel: 'ปิด',
    monthPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนปี',
    yearPickerHeaderAriaLabel: '{0}, เลือกเพื่อเปลี่ยนเดือน',

    isRequiredErrorMessage: t('stripe.isRequiredErrorMessage'),

    invalidInputErrorMessage: 'รูปแบบวันที่ไม่ถูกต้อง',
  };

  // Processing dialog style
  const spinnerStyles = {
    circle: {
      height: 56,
      width: 56,
      borderWidth: 4,
    },
  };

  const getMonth = (goBack) => {
    let monthNames = [
      t('stripe.months01'),
      t('stripe.months02'),
      t('stripe.months03'),
      t('stripe.months04'),
      t('stripe.months05'),
      t('stripe.months06'),
      t('stripe.months07'),
      t('stripe.months08'),
      t('stripe.months09'),
      t('stripe.months10'),
      t('stripe.months11'),
      t('stripe.months12'),
    ];

    let d = new Date();

    let adjustDate = new Date(d.getFullYear(), d.getMonth() - goBack, 1);

    let year = adjustDate.getFullYear() + 543;

    return {
      month: adjustDate.getMonth(),
      year: adjustDate.getFullYear(),
      key: adjustDate.getMonth() + 1,
      text: monthNames[adjustDate.getMonth()] + ' ' + year,
    };
  };

  const [queryMonth, setQueryMonth] = useState(
    (sessionStorage.getItem('stripe-queryMonth-key') && {
      key: sessionStorage.getItem('stripe-queryMonth-key'),
      text: sessionStorage.getItem('stripe-queryMonth-text'),
    }) || { key: getMonth(0).year + '' + getMonth(0).key, text: t('stripe.thisMonth') }
  );

  const getFrom = (month, year) => {
    let _firstDay = new Date(year, month, 1);

    return formatDate(_firstDay);
  };

  const getTo = (month, year) => {
    let _lastDay = new Date(year, month + 1, 1);

    return formatDate(_lastDay);
  };

  const getFrom2 = (month, year) => {
    let _firstDay = new Date(year, month, 1);

    return Math.floor(_firstDay.getTime() / 1000);
  };

  const getTo2 = (month, year) => {
    let _lastDay = new Date(year, month + 1, 1);

    return Math.floor(_lastDay.getTime() / 1000);
  };

  const formatDate = (d) => {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  };

  const [from, setFrom] = useState(sessionStorage.getItem('stripe-from') || getFrom(getMonth(0).month, getMonth(0).year));
  const [to, setTo] = useState(sessionStorage.getItem('stripe-to') || getTo(getMonth(0).month, getMonth(0).year));

  const [from2, setFrom2] = useState(sessionStorage.getItem('stripe-from2') || getFrom2(getMonth(0).month, getMonth(0).year));
  const [to2, setTo2] = useState(sessionStorage.getItem('stripe-to2') || getTo2(getMonth(0).month, getMonth(0).year));

  const [date, setDate] = useState(sessionStorage.getItem('stripe-date') ? new Date(sessionStorage.getItem('stripe-date')) : new Date());

  let _pageDropdown = [];

  for (let i = 1; i <= 35; i++) {
    _pageDropdown.push({
      key: i,
      text: t('stripe.page') + ' ' + i,
      iconProps: { iconName: 'Page' },
      onClick: () => {
        console.log('Selected page: ' + i);
        setCurrentPage(i);
      },
    });
  }

  const [pageDropdown, setPageDropdown] = useState(_pageDropdown);

  function getDateText(monthObject) {
    if (monthObject.text === 'เดือนนี้' || monthObject.text === 'This Month') return t('stripe.thisMonth');

    let monthNames = [
      t('stripe.months01'),
      t('stripe.months02'),
      t('stripe.months03'),
      t('stripe.months04'),
      t('stripe.months05'),
      t('stripe.months06'),
      t('stripe.months07'),
      t('stripe.months08'),
      t('stripe.months09'),
      t('stripe.months10'),
      t('stripe.months11'),
      t('stripe.months12'),
    ];

    let _monthIndex = Number(monthObject.key.substring(4, 6)) - 1;
    let _year = Number(monthObject.key.substring(0, 4));
    if (i18n.language === 'th') {
      _year = _year + 543;
    }

    return monthNames[_monthIndex] + ' ' + _year;
  }

  const commandBarItems = [
    {
      key: documentType.key,
      text: documentType.text,
      iconProps: { iconName: 'ProductList' },
      disabled: !loadDataComplete || isCreateDocument || search,
      subMenuProps: {
        items: [
          {
            key: 'paid',
            text: 'Paid',
            iconProps: { iconName: 'ProductList' },
            onClick: () => {
              console.log('paid');
              setDocumentType({
                key: 'paid',
                text: 'Paid',
              });

              sessionStorage.setItem('stripe-documentType-key', 'paid');
              sessionStorage.setItem('stripe-documentType-text', 'Paid');

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
          },
          {
            key: 'open',
            text: 'Open',
            iconProps: { iconName: 'ProductList' },
            onClick: () => {
              console.log('open');
              setDocumentType({
                key: 'open',
                text: 'Open',
              });

              sessionStorage.setItem('stripe-documentType-key', 'open');
              sessionStorage.setItem('stripe-documentType-text', 'Open');

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
          },
          {
            key: 'uncollectible',
            text: 'Uncollectible',
            iconProps: { iconName: 'ProductList' },
            onClick: () => {
              console.log('uncollectible');
              setDocumentType({
                key: 'uncollectible',
                text: 'Uncollectible',
              });

              sessionStorage.setItem('stripe-documentType-key', 'uncollectible');
              sessionStorage.setItem('stripe-documentType-text', 'Uncollectible');

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
          },
          {
            key: 'draft',
            text: 'Draft',
            iconProps: { iconName: 'ProductList' },
            onClick: () => {
              console.log('draft');
              setDocumentType({
                key: 'draft',
                text: 'Draft',
              });

              sessionStorage.setItem('stripe-documentType-key', 'draft');
              sessionStorage.setItem('stripe-documentType-text', 'Draft');

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
          },
          {
            key: 'void',
            text: 'Void',
            iconProps: { iconName: 'ProductList' },
            onClick: () => {
              console.log('void');
              setDocumentType({
                key: 'void',
                text: 'Void',
              });

              sessionStorage.setItem('stripe-documentType-key', 'void');
              sessionStorage.setItem('stripe-documentType-text', 'Void');

              setLoadDataComplete(false);
              setItems([]);
              setGetNewDocuments(true);
            },
          },
        ],
      },
    },
    {
      key: queryMonth.key,
      text: getDateText(queryMonth),
      iconProps: { iconName: 'Calendar' },
      disabled: !loadDataComplete || isCreateDocument || search,
      subMenuProps: {
        items: [
          {
            key: 'queryMonth',
          },
        ],
        onRenderMenuList: () => {
          return (
            <div style={{ width: 220 }}>
              <Calendar
                onSelectDate={(_date) => {
                  let monthNames = [
                    t('stripe.months01'),
                    t('stripe.months02'),
                    t('stripe.months03'),
                    t('stripe.months04'),
                    t('stripe.months05'),
                    t('stripe.months06'),
                    t('stripe.months07'),
                    t('stripe.months08'),
                    t('stripe.months09'),
                    t('stripe.months10'),
                    t('stripe.months11'),
                    t('stripe.months12'),
                  ];

                  setDate(_date);

                  sessionStorage.setItem('stripe-date', _date.toISOString());

                  let adjustDate = _date;

                  let year = adjustDate.getFullYear() + 543;

                  setQueryMonth({
                    key: adjustDate.getFullYear() + '' + String(adjustDate.getMonth() + 1).padStart(2, '0'),
                    text: monthNames[adjustDate.getMonth()] + ' ' + year,
                  });

                  sessionStorage.setItem('stripe-queryMonth-key', adjustDate.getFullYear() + '' + String(adjustDate.getMonth() + 1).padStart(2, '0'));
                  sessionStorage.setItem('stripe-queryMonth-text', monthNames[adjustDate.getMonth()] + ' ' + year);

                  setFrom(getFrom(adjustDate.getMonth(), adjustDate.getFullYear()));
                  setTo(getTo(adjustDate.getMonth(), adjustDate.getFullYear()));

                  sessionStorage.setItem('stripe-from', getFrom(adjustDate.getMonth(), adjustDate.getFullYear()));
                  sessionStorage.setItem('stripe-to', getTo(adjustDate.getMonth(), adjustDate.getFullYear()));

                  setFrom2(getFrom2(adjustDate.getMonth(), adjustDate.getFullYear()));
                  setTo2(getTo2(adjustDate.getMonth(), adjustDate.getFullYear()));

                  sessionStorage.setItem('stripe-from2', getFrom2(adjustDate.getMonth(), adjustDate.getFullYear()));
                  sessionStorage.setItem('stripe-to2', getTo2(adjustDate.getMonth(), adjustDate.getFullYear()));

                  setLoadDataComplete(false);
                  setItems([]);
                  setGetNewDocuments(true);
                }}
                isMonthPickerVisible={true}
                highlightSelectedMonth={true}
                isDayPickerVisible={false}
                dateRangeType={DateRangeType.Day}
                autoNavigateOnSelection={false}
                showGoToToday={false}
                value={date}
                strings={DayPickerStrings}
                showSixWeeksByDefault={true}
              />
            </div>
          );
        },
      },
    },
    {
      key: currentPage,
      text: t('stripe.page') + ' ' + currentPage,
      iconProps: { iconName: 'Page' },
      disabled: !loadDataComplete || isCreateDocument || search,
      subMenuProps: {
        items: pageDropdown,
      },
    },
    {
      key: 'refresh',
      text: t('stripe.refresh'),
      iconProps: { iconName: 'Refresh' },
      disabled: !loadDataComplete || isCreateDocument || search,
      onClick: () => {
        console.log('Refresh');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);
      },
    },
  ];

  const overflowItems = [
    {
      key: 'disconnect',
      text: t('stripe.disconnect'),
      onClick: () => {
        console.log('stripe disconnect!');
        setDialogConfirm((prev) => ({
          ...prev,
          isClick: true,
          header: t('stripe.disconnect'),
          message: t('stripe.disconnectConfirm'),
          onConfirm: () => {
            disconnect(true);
            setDialogConfirm((prev) => ({
              ...prev,
              isClick: false,
            }));
          },
          onCancel: () =>
            setDialogConfirm((prev) => ({
              ...prev,
              isClick: false,
            })),
        }));
      },
      iconProps: { iconName: 'PlugDisconnected' },
      disabled: !loadDataComplete || isCreateDocument || search,
    },
  ];

  const toThaiDateString = (isoDateTime) => {
    let date = '';
    date = new Date(isoDateTime);

    let year = date.getFullYear() + 543;
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let numOfDay = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let second = date.getSeconds().toString().padStart(2, '0');

    return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
  };

  const createDocument = (documentType, item) => {
    let documentPath = '/etax/documents/receipts';

    switch (documentType) {
      case 'RECEIPT-TAXINVOICE':
        documentPath = '/etax/documents/receipts-taxinvoices';
        break;
      case 'RECEIPT-TAXINVOICE-ABB':
        documentPath = '/etax/documents/receipts-taxinvoices-abb';
        break;
      case 'RECEIPT':
        documentPath = '/etax/documents/receipts';
        break;
      case 'INVOICE-TAXINVOICE':
        documentPath = '/etax/documents/invoices-taxinvoices';
        break;
      case 'DELIVERYORDER-TAXINVOICE':
        documentPath = '/etax/documents/deliveryorders-taxinvoices';
        break;
      case 'TAXINVOICE':
        documentPath = '/etax/documents/taxinvoices';
        break;
      default:
        break;
    }

    let _date = new Date(item.documentDateValue);

    let _dateBE = `${_date.getDate()}`.padStart(2, '0') + '/' + `${_date.getMonth() + 1}`.padStart(2, '0') + '/' + (_date.getFullYear() + 543);
    let _dateCE = `${_date.getDate()}`.padStart(2, '0') + '/' + `${_date.getMonth() + 1}`.padStart(2, '0') + '/' + _date.getFullYear();

    let _customer = {
      addressLineOne: item.addressLineOne,
      addressLineTwo: item.addressLineTwo,
      branchNumber: item.branchNumber,
      branchText: item.branchText,
      email: item.customerEmail,
      name: item.customerName,
      phone: item.customerPhone,
      phoneCountryCode: '+66',
      postcode: item.postcode,
      taxId: item.taxId,
      taxNumberType: item.taxNumberType,
      language: 'th',
      unstructure: true,
    };

    history.push({
      pathname: documentPath,
      state: {
        command: 'EDIT',
        amountTotal: item.amountTotal,
        company: {
          ...company,
          includeVat: item.includeVat,
        },
        customer: _customer,
        date: _date,
        dateBE: _dateBE,
        dateCE: _dateCE,
        discount: item.discount,
        grandTotal: item.grandTotal,
        items: item.items,
        reference: '',
        note: '',
        number: item.number,
        percentVat: percentVat,
        receivedBy: '',
        vatTotal: item.vatTotal,
        reIssue: false,
        backUrl: '/etax/sources/stripe',
        includeVat: item.includeVat,
      },
    });
  };

  useEffect(() => {
    console.log('userEffect initial company call!');

    instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
          .get(API_URL + '/etax/companies', {
            headers: {
              Authorization: 'Bearer ' + tokenResponse.accessToken,
            },
          })
          .then(
            (response) => {
              if (response.data[0]) {
                setCompany(response.data[0]);

                if (response.data[0].registerVat) {
                  setRegisterVat(true);
                } else {
                  setRegisterVat(false);
                }
              } else {
                history.push({
                  pathname: '/etax/companies/profiles',
                  state: {},
                });
              }
            },
            (error) => {
              console.log(error);
            }
          );
      })
      .catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log(error);
        instance.acquireTokenRedirect(silentRequest);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getNewDocuments) {
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then(async (tokenResponse) => {
          if (search) {
            console.log('search Running!!!');
            console.log('search:', search, true);

            axios
              .get('http://localhost:7071/api/Stripe_searchInvoices', {
                params: {
                  access_token: access_token,
                  search: search,
                },
              })
              .then(async (response) => {
                if (response.data.invoices.length) {
                  const _number = search;

                  await axios
                    .get(API_URL + `/documents?number=${_number}`, {
                      headers: {
                        Authorization: 'Bearer ' + tokenResponse.accessToken,
                        'Content-Type': 'application/json',
                      },
                    })
                    .then((responseAllDocs) => {
                      let invoice_list = response.data.invoices || [];
                      let total_items = response.data.invoices.length;

                      if (invoice_list.length > 0) {
                        if (primarySort === 'documentDate') {
                          if (!isSortedDescendingDocumentDate) {
                            invoice_list.sort(function (a, b) {
                              let aa = (a.created + 25200) * 1000;
                              let bb = (b.created + 25200) * 1000;
                              return aa < bb ? -1 : aa > bb ? 1 : 0;
                            });
                          } else {
                            invoice_list.sort(function (a, b) {
                              let aa = (a.created + 25200) * 1000;
                              let bb = (b.created + 25200) * 1000;
                              return aa < bb ? 1 : aa > bb ? -1 : 0;
                            });
                          }
                        } else if (primarySort === 'number') {
                          if (isSortedDescendingNumber) {
                            invoice_list.sort((a, b) => {
                              return b.number - a.number;
                            });
                          } else {
                            invoice_list.sort((a, b) => {
                              return a.number - b.number;
                            });
                          }
                        } else if (primarySort === 'customerName') {
                          if (isSortedDescendingCustomerName) {
                            invoice_list.sort((a, b) => {
                              if (b.customer_name < a.customer_name) {
                                return -1;
                              }
                              if (b.customer_name > a.customer_name) {
                                return 1;
                              }
                              return 0;
                            });
                          } else {
                            invoice_list.sort((a, b) => {
                              if (a.customer_name < b.customer_name) {
                                return -1;
                              }
                              if (a.customer_name > b.customer_name) {
                                return 1;
                              }
                              return 0;
                            });
                          }
                        } else if (primarySort === 'vatTotal') {
                          if (isSortedDescendingVatTotal) {
                            invoice_list.sort(function (a, b) {
                              return b.tax - a.tax;
                            });
                          } else {
                            invoice_list.sort(function (a, b) {
                              return a.tax - b.tax;
                            });
                          }
                        } else if (primarySort === 'grandTotal') {
                          if (isSortedDescendingGrandTotal) {
                            invoice_list.sort(function (a, b) {
                              return b.total - a.total;
                            });
                          } else {
                            invoice_list.sort(function (a, b) {
                              return a.total - b.total;
                            });
                          }
                        }
                      }

                      let _pageDropdown = [];

                      for (let i = 1; i <= Math.ceil(total_items / pageSize); i++) {
                        _pageDropdown.push({
                          key: i,
                          text: 'หน้า ' + i,
                          iconProps: { iconName: 'Page' },
                          onClick: () => {
                            console.log('Selected page: ' + i);
                            setCurrentPage(i);
                          },
                        });
                      }

                      setPageDropdown(_pageDropdown);

                      if (currentPage > Math.ceil(total_items / pageSize)) {
                        setCurrentPage(1);
                      }

                      setPageData(paginate(total_items, 1, pageSize, 10));

                      const _docs = [];

                      for (let i = 0; i < invoice_list.length; i++) {
                        let _documentDate = toThaiDateString((invoice_list[i].created + 25200) * 1000).split(' ')[0];

                        const _items = [];
                        invoice_list[i].lines.data.forEach((_item, index) => {
                          let _discount =
                            _item.discount_amounts.reduce(
                              (accumulator, obj) => (_item.discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
                              0
                            ) / _item.quantity;

                          let _price = _item.price.unit_amount / 100;
                          let _total = (_price - _discount) * _item.quantity;

                          _items.push({
                            number: index + 1 + '',
                            description: _item.description,
                            quantity: _item.quantity,
                            unitCode: '',
                            unitName: '-',
                            price: _price,
                            discount: _discount,
                            percentVat: _item.tax_rates[0].percentage > 0 ? percentVat : zeroVat,
                            percentVatText: _item.tax_rates[0].percentage > 0 ? percentVatText : zeroVatText,
                            total: _total,
                          });
                        });

                        let _taxId = 'N/A';
                        let _taxNumberType = 'OTHR';
                        let _branchNumber = '';
                        let _branchText = '';

                        invoice_list[i].customer_tax_ids.forEach((_tax) => {
                          if (_tax.type === 'th_vat') {
                            _taxId = _tax.value;
                            _taxNumberType = 'TXID';
                            _branchNumber = '00000';
                            _branchText = 'สำนักงานใหญ่';
                          }
                        });

                        let _discountTotal = invoice_list[i].total_discount_amounts.reduce(
                          (accumulator, obj) => (invoice_list[i].discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
                          0
                        );

                        _docs.push({
                          key: invoice_list[i].id,
                          number: invoice_list[i].number,
                          documentDate: _documentDate,
                          documentDateValue: (invoice_list[i].created + 25200) * 1000,
                          // createdTime: _createdTime,
                          // createdTimestamp: _createdTimestamp,
                          customerName: invoice_list[i].customer_name,
                          customerEmail: invoice_list[i].customer_email,
                          customerPhone: invoice_list[i].customer_phone.replace('+66', '0'),
                          addressLineOne: invoice_list[i].customer_address?.line1,
                          addressLineTwo: invoice_list[i].customer_address?.line2 + ' ' + invoice_list[i].customer_address?.city,
                          countryName: invoice_list[i].customer_address?.country,
                          postcode: invoice_list[i].customer_address?.postal_code,
                          discount: _discountTotal,
                          amountTotal: invoice_list[i].total_excluding_tax / 100,
                          vatTotal: invoice_list[i].tax / 100,
                          grandTotal: invoice_list[i].total / 100,
                          includeVat: invoice_list[i].total_tax_amounts[0].inclusive,
                          items: _items,
                          taxId: _taxId,
                          taxNumberType: _taxNumberType,
                          branchNumber: _branchNumber,
                          branchText: _branchText,
                          // amount: invoice_list[i].amount.value,
                          etaxCreated: responseAllDocs.data.some((_allDocs) => _allDocs.data.number === invoice_list[i].number),
                        });
                      }

                      console.log('_docs', _docs);
                      setItems(_docs);

                      setLoadDataComplete(true);
                      setGetNewDocuments(false);
                      setIsCreateDocumentComplete(false);
                    });
                } else {
                  setItems([]);

                  setLoadDataComplete(true);
                  setGetNewDocuments(false);
                  setIsCreateDocumentComplete(false);
                }
              })
              .catch((error) => {
                setItems([]);

                setLoadDataComplete(true);
                setGetNewDocuments(false);
                setIsCreateDocumentComplete(false);
              });
          } else {
            console.log('getNewOrder Running!!!');

            const [response, responseAllDocs] = await Promise.all([
              axios
                .get('http://localhost:7071/api/Stripe_getInvoices', {
                  params: {
                    access_token: access_token,
                    page_size: pageSize,
                    from: from2,
                    to: to2,
                    status: documentType.key,
                  },
                })
                .catch((error) => console.log(error)),
              axios
                .get(API_URL + '/etax/documents/ALL/all?from=' + from + '&to=' + to + '&date=' + dateType.key, {
                  headers: {
                    Authorization: 'Bearer ' + tokenResponse.accessToken,
                  },
                })
                .catch((error) => console.log(error)),
            ]);

            console.log('Paypal list invoice: ', response);
            // console.log('responseAllDocs', responseAllDocs);

            let invoice_list = response.data.invoices || [];
            let total_items = response.data.invoices.length;
            // let invoice_list = data || [];
            // let total_items = data.length;

            setAllDocs(responseAllDocs.data);

            if (invoice_list.length > 0) {
              if (primarySort === 'documentDate') {
                if (!isSortedDescendingDocumentDate) {
                  invoice_list.sort(function (a, b) {
                    let aa = (a.created + 25200) * 1000;
                    let bb = (b.created + 25200) * 1000;
                    return aa < bb ? -1 : aa > bb ? 1 : 0;
                  });
                } else {
                  invoice_list.sort(function (a, b) {
                    let aa = (a.created + 25200) * 1000;
                    let bb = (b.created + 25200) * 1000;
                    return aa < bb ? 1 : aa > bb ? -1 : 0;
                  });
                }
              } else if (primarySort === 'number') {
                if (isSortedDescendingNumber) {
                  invoice_list.sort((a, b) => {
                    return b.number - a.number;
                  });
                } else {
                  invoice_list.sort((a, b) => {
                    return a.number - b.number;
                  });
                }
              } else if (primarySort === 'customerName') {
                if (isSortedDescendingCustomerName) {
                  invoice_list.sort((a, b) => {
                    if (b.customer_name < a.customer_name) {
                      return -1;
                    }
                    if (b.customer_name > a.customer_name) {
                      return 1;
                    }
                    return 0;
                  });
                } else {
                  invoice_list.sort((a, b) => {
                    if (a.customer_name < b.customer_name) {
                      return -1;
                    }
                    if (a.customer_name > b.customer_name) {
                      return 1;
                    }
                    return 0;
                  });
                }
              } else if (primarySort === 'vatTotal') {
                if (isSortedDescendingVatTotal) {
                  invoice_list.sort(function (a, b) {
                    return b.tax - a.tax;
                  });
                } else {
                  invoice_list.sort(function (a, b) {
                    return a.tax - b.tax;
                  });
                }
              } else if (primarySort === 'grandTotal') {
                if (isSortedDescendingGrandTotal) {
                  invoice_list.sort(function (a, b) {
                    return b.total - a.total;
                  });
                } else {
                  invoice_list.sort(function (a, b) {
                    return a.total - b.total;
                  });
                }
              }
            }

            setDocuments(invoice_list);

            let _pageDropdown = [];

            for (let i = 1; i <= Math.ceil(total_items / pageSize); i++) {
              _pageDropdown.push({
                key: i,
                text: 'หน้า ' + i,
                iconProps: { iconName: 'Page' },
                onClick: () => {
                  console.log('Selected page: ' + i);
                  setCurrentPage(i);
                },
              });
            }

            setPageDropdown(_pageDropdown);

            if (currentPage > Math.ceil(total_items / pageSize)) {
              setCurrentPage(1);
            }

            setPageData(paginate(total_items, 1, pageSize, 10));

            const _docs = [];

            for (let i = (currentPage - 1) * pageSize; i < Math.min(currentPage * pageSize, invoice_list.length); i++) {
              let _documentDate = toThaiDateString((invoice_list[i].created + 25200) * 1000).split(' ')[0];

              const _items = [];
              invoice_list[i].lines.data.forEach((_item, index) => {
                let _discount =
                  _item.discount_amounts.reduce(
                    (accumulator, obj) => (_item.discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
                    0
                  ) / _item.quantity;

                let _price = _item.price.unit_amount / 100;
                let _total = (_price - _discount) * _item.quantity;

                _items.push({
                  number: index + 1 + '',
                  description: _item.description,
                  quantity: _item.quantity,
                  unitCode: '',
                  unitName: '-',
                  price: _price,
                  discount: _discount,
                  percentVat: _item.tax_rates[0].percentage > 0 ? percentVat : zeroVat,
                  percentVatText: _item.tax_rates[0].percentage > 0 ? percentVatText : zeroVatText,
                  total: _total,
                });
              });

              let _taxId = 'N/A';
              let _taxNumberType = 'OTHR';
              let _branchNumber = '';
              let _branchText = '';

              invoice_list[i].customer_tax_ids.forEach((_tax) => {
                if (_tax.type === 'th_vat') {
                  _taxId = _tax.value;
                  _taxNumberType = 'TXID';
                  _branchNumber = '00000';
                  _branchText = 'สำนักงานใหญ่';
                }
              });

              let _discountTotal = invoice_list[i].total_discount_amounts.reduce(
                (accumulator, obj) => (invoice_list[i].discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
                0
              );

              _docs.push({
                key: invoice_list[i].id,
                number: invoice_list[i].number,
                documentDate: _documentDate,
                documentDateValue: (invoice_list[i].created + 25200) * 1000,
                // createdTime: _createdTime,
                // createdTimestamp: _createdTimestamp,
                customerName: invoice_list[i].customer_name,
                customerEmail: invoice_list[i].customer_email,
                customerPhone: invoice_list[i].customer_phone.replace('+66', '0'),
                addressLineOne: invoice_list[i].customer_address?.line1,
                addressLineTwo: invoice_list[i].customer_address?.line2 + ' ' + invoice_list[i].customer_address?.city,
                countryName: invoice_list[i].customer_address?.country,
                postcode: invoice_list[i].customer_address?.postal_code,
                discount: _discountTotal,
                amountTotal: invoice_list[i].total_excluding_tax / 100,
                vatTotal: invoice_list[i].tax / 100,
                grandTotal: invoice_list[i].total / 100,
                includeVat: invoice_list[i].total_tax_amounts[0].inclusive,
                items: _items,
                taxId: _taxId,
                taxNumberType: _taxNumberType,
                branchNumber: _branchNumber,
                branchText: _branchText,
                // amount: invoice_list[i].amount.value,
                etaxCreated: responseAllDocs.data.some((_allDocs) => _allDocs.data.number === invoice_list[i].number),
              });
            }

            console.log('_docs', _docs);
            setItems(_docs);

            setLoadDataComplete(true);
            setGetNewDocuments(false);
            setIsCreateDocumentComplete(false);
          }
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          // instance.acquireTokenRedirect(silentRequest);
          // disconnect(true);

          //   setLoadDataComplete(true);
          //   setGetNewDocuments(false);
          //   setIsCreateDocumentComplete(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getNewDocuments]);

  useEffect(() => {
    sessionStorage.setItem('stripe-currentPage', currentPage);

    if (documents.length > 0) {
      const invoice_list = [...documents];
      const _docs = [];

      for (let i = (currentPage - 1) * pageSize; i < Math.min(currentPage * pageSize, invoice_list.length); i++) {
        let _documentDate = toThaiDateString((invoice_list[i].created + 25200) * 1000).split(' ')[0];

        const _items = [];
        invoice_list[i].lines.data.forEach((_item, index) => {
          let _discount =
            _item.discount_amounts.reduce(
              (accumulator, obj) => (_item.discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
              0
            ) / _item.quantity;

          let _price = _item.price.unit_amount / 100;
          let _total = (_price - _discount) * _item.quantity;

          _items.push({
            number: index + 1 + '',
            description: _item.description,
            quantity: _item.quantity,
            unitCode: '',
            unitName: '-',
            price: _price,
            discount: _discount,
            percentVat: _item.tax_rates[0].percentage > 0 ? percentVat : zeroVat,
            percentVatText: _item.tax_rates[0].percentage > 0 ? percentVatText : zeroVatText,
            total: _total,
          });
        });

        let _taxId = 'N/A';
        let _taxNumberType = 'OTHR';
        let _branchNumber = '';
        let _branchText = '';

        invoice_list[i].customer_tax_ids.forEach((_tax) => {
          if (_tax.type === 'th_vat') {
            _taxId = _tax.value;
            _taxNumberType = 'TXID';
            _branchNumber = '00000';
            _branchText = 'สำนักงานใหญ่';
          }
        });

        let _discountTotal = invoice_list[i].total_discount_amounts.reduce(
          (accumulator, obj) => (invoice_list[i].discounts.includes(obj.discount) ? accumulator + obj.amount / 100 : accumulator + 0),
          0
        );

        _docs.push({
          key: invoice_list[i].id,
          number: invoice_list[i].number,
          documentDate: _documentDate,
          documentDateValue: (invoice_list[i].created + 25200) * 1000,
          // createdTime: _createdTime,
          // createdTimestamp: _createdTimestamp,
          customerName: invoice_list[i].customer_name,
          customerEmail: invoice_list[i].customer_email,
          customerPhone: invoice_list[i].customer_phone.replace('+66', '0'),
          addressLineOne: invoice_list[i].customer_address?.line1,
          addressLineTwo: invoice_list[i].customer_address?.line2 + ' ' + invoice_list[i].customer_address?.city,
          countryName: invoice_list[i].customer_address?.country,
          postcode: invoice_list[i].customer_address?.postal_code,
          discount: _discountTotal,
          amountTotal: invoice_list[i].total_excluding_tax / 100,
          vatTotal: invoice_list[i].tax / 100,
          grandTotal: invoice_list[i].total / 100,
          includeVat: invoice_list[i].total_tax_amounts[0].inclusive,
          items: _items,
          taxId: _taxId,
          taxNumberType: _taxNumberType,
          branchNumber: _branchNumber,
          branchText: _branchText,
          // amount: invoice_list[i].amount.value,
          etaxCreated: allDocs.some((_allDocs) => _allDocs.data.number === invoice_list[i].number),
        });
      }

      setItems(_docs);

      setLoadDataComplete(true);
      setGetNewDocuments(false);
      setIsCreateDocumentComplete(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    console.log('isCreateDocumentComplete useEffect: ', isCreateDocumentComplete);

    if (loadDataComplete && !isCreateDocument) {
      let _items = selection.getItems();
      console.log('_items: ', _items);

      let _selectedItems = selection.getSelection();

      if (isCreateDocumentComplete) {
        setIsCreateDocumentComplete(false);

        for (let i = 0; i < _items.length; i++) {
          if (_items[i].status != '') {
            _items[i].status = '';
          }
        }
      } else {
        for (let i = 0; i < _items.length; i++) {
          if (_items[i].status != '') {
            _items[i].status = '';
          }
        }

        for (let i = 0; i < _selectedItems.length; i++) {
          console.log('select item key: ', _selectedItems[i].key);

          for (let j = 0; j < _items.length; j++) {
            if (_items[j].key === _selectedItems[i].key) {
              console.log('set pending item key: ', _items[j].key);
              _items[j].status = 'pending';
              console.log('_items: ', _items);
            }
          }
        }
      }

      setItems(_items);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);

  const onPageChange = (selectedPageIndex) => {
    console.log('selectedPageIndex: ', selectedPageIndex);
    setCurrentPage(selectedPageIndex + 1);
  };

  const columns = [
    {
      key: 'column1',
      name: t('stripe.documentDate'),
      fieldName: 'documentDate',
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isSorted: primarySort === 'documentDate' ? true : false,
      isSortedDescending: isSortedDescendingDocumentDate,
      isSortedAscending: !isSortedDescendingDocumentDate,
      onColumnClick: () => {
        console.log('Sort document createTime!');
        setPrimarySort('documentDate');
        setIsSortedDescendingDocumentDate(!isSortedDescendingDocumentDate);

        sessionStorage.setItem('stripe-primarySort', 'documentDate');
        sessionStorage.setItem('stripe-sort-documentDate', !isSortedDescendingDocumentDate === false ? 'false' : 'true');

        sessionStorage.removeItem('stripe-sort-createdTime');
        sessionStorage.removeItem('stripe-sort-number');
        sessionStorage.removeItem('stripe-sort-customerName');
        sessionStorage.removeItem('stripe-sort-vatTotal');
        sessionStorage.removeItem('stripe-sort-grandTotal');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);

        setIsCreateDocumentComplete(false);
        setSelectedItems([]);
      },
      data: 'number',
      onRender: (item) => {
        return <span>{item.documentDate}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column2',
      name: t('stripe.number'),
      fieldName: 'number',
      minWidth: 50,
      maxWidth: 100,
      isRowHeader: true,
      isResizable: true,
      isSorted: primarySort === 'number' ? true : false,
      isSortedDescending: isSortedDescendingNumber,
      isSortedAscending: !isSortedDescendingNumber,
      onColumnClick: () => {
        console.log('Sort document number!');
        setPrimarySort('number');
        setIsSortedDescendingNumber(!isSortedDescendingNumber);

        sessionStorage.setItem('stripe-primarySort', 'number');
        sessionStorage.setItem('stripe-sort-number', !isSortedDescendingNumber === false ? 'false' : 'true');

        sessionStorage.removeItem('stripe-sort-createdTime');
        sessionStorage.removeItem('stripe-sort-documentDate');
        sessionStorage.removeItem('stripe-sort-customerName');
        sessionStorage.removeItem('stripe-sort-vatTotal');
        sessionStorage.removeItem('stripe-sort-grandTotal');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);

        setIsCreateDocumentComplete(false);
        setSelectedItems([]);
      },
      data: 'string',
      onRender: (item) => {
        return <span>{item.number}</span>;
      },
      // isPadded: true,
    },
    {
      key: 'column3',
      name: t('stripe.customerName'),
      fieldName: 'customerName',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      isSorted: primarySort === 'customerName' ? true : false,
      isSortedDescending: isSortedDescendingCustomerName,
      isSortedAscending: !isSortedDescendingCustomerName,
      onColumnClick: () => {
        console.log('Sort document customerName!');
        setPrimarySort('customerName');
        setIsSortedDescendingCustomerName(!isSortedDescendingCustomerName);

        sessionStorage.setItem('stripe-primarySort', 'customerName');
        sessionStorage.setItem('stripe-sort-customerName', !isSortedDescendingCustomerName === false ? 'false' : 'true');

        sessionStorage.removeItem('stripe-sort-createdTime');
        sessionStorage.removeItem('stripe-sort-documentDate');
        sessionStorage.removeItem('stripe-sort-number');
        sessionStorage.removeItem('stripe-sort-vatTotal');
        sessionStorage.removeItem('stripe-sort-grandTotal');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);

        setIsCreateDocumentComplete(false);
        setSelectedItems([]);
      },
      data: 'string',
      onRender: (item) => {
        return <span>{item.customerName}</span>;
      },
      isPadded: true,
    },
    {
      key: 'column4',
      name: t('stripe.customerEmail'),
      fieldName: 'customerEmail',
      minWidth: 100,
      maxWidth: 150,
      isResizable: true,
      onColumnClick: '',
      data: 'string',
      onRender: (item) => {
        return <span>{item.customerEmail}</span>;
      },
      isPadded: true,
    },
    {
      key: 'column5',
      name: t('stripe.vatTotal'),
      fieldName: 'vatTotal',
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isSorted: primarySort === 'vatTotal' ? true : false,
      isSortedDescending: isSortedDescendingVatTotal,
      isSortedAscending: !isSortedDescendingVatTotal,
      onColumnClick: () => {
        console.log('Sort document grandTotal!');
        setPrimarySort('vatTotal');
        setIsSortedDescendingVatTotal(!isSortedDescendingVatTotal);

        sessionStorage.setItem('stripe-primarySort', 'vatTotal');
        sessionStorage.setItem('stripe-sort-vatTotal', !isSortedDescendingVatTotal === false ? 'false' : 'true');

        sessionStorage.removeItem('stripe-sort-createdTime');
        sessionStorage.removeItem('stripe-sort-customerName');
        sessionStorage.removeItem('stripe-sort-number');
        sessionStorage.removeItem('stripe-sort-vatTotal');
        sessionStorage.removeItem('stripe-sort-documentDate');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);

        setIsCreateDocumentComplete(false);
        setSelectedItems([]);
      },
      data: 'string',
      onRender: (item) => {
        return (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {item.vatTotal.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
          </span>
        );
      },
      isPadded: true,
    },
    {
      key: 'column6',
      name: t('stripe.grandTotal'),
      fieldName: 'grandTotal',
      minWidth: 100,
      maxWidth: 100,
      isResizable: true,
      isSorted: primarySort === 'grandTotal' ? true : false,
      isSortedDescending: isSortedDescendingGrandTotal,
      isSortedAscending: !isSortedDescendingGrandTotal,
      onColumnClick: () => {
        console.log('Sort document grandTotal!');
        setPrimarySort('grandTotal');
        setIsSortedDescendingGrandTotal(!isSortedDescendingGrandTotal);

        sessionStorage.setItem('stripe-primarySort', 'grandTotal');
        sessionStorage.setItem('stripe-sort-grandTotal', !isSortedDescendingGrandTotal === false ? 'false' : 'true');

        sessionStorage.removeItem('stripe-sort-createdTime');
        sessionStorage.removeItem('stripe-sort-customerName');
        sessionStorage.removeItem('stripe-sort-number');
        sessionStorage.removeItem('stripe-sort-vatTotal');
        sessionStorage.removeItem('stripe-sort-documentDate');

        setLoadDataComplete(false);
        setItems([]);
        setGetNewDocuments(true);

        setIsCreateDocumentComplete(false);
        setSelectedItems([]);
      },
      data: 'string',
      onRender: (item) => {
        return (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {item.grandTotal.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })}
          </span>
        );
      },
      isPadded: true,
    },
    {
      key: 'column7',
      name: 'Leceipt',
      fieldName: 'etaxCreated',
      minWidth: 50,
      maxWidth: 50,
      isResizable: true,
      data: 'string',
      onRender: (item) => {
        if (item.etaxCreated) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Icon iconName="SkypeCircleCheck" style={{ fontSize: '20px', color: 'green' }} />
            </div>
          );
        }
      },
    },
    {
      key: 'column8',
      name: '',
      fieldName: 'command',
      minWidth: 120,
      maxWidth: 120,
      isResizable: true,
      data: 'string',
      onColumnClick: '',
      onRender: (item) => {
        if (isCreateDocument || isCreateDocumentComplete) {
          if (item.status === 'pending') {
            return <span style={{ color: '#106EBE' }}>{t('stripe.pending')}</span>;
          } else if (item.status === 'processing') {
            return (
              <Stack horizontal horizontalAlign="start">
                <Spinner label={t('stripe.processing')} labelPosition="right" style={{ marginLeft: '0px' }} />
              </Stack>
            );
          } else if (item.status === 'successful') {
            return <span style={{ color: 'green' }}>{t('stripe.success')}</span>;
          } else if (item.status === 'fail') {
            return <span style={{ color: 'red' }}>{t('stripe.fail')}</span>;
          }
        } else {
          return (
            <span data-selection-disabled={true}>
              <DefaultButton
                text={t('stripe.create')}
                iconProps={{ iconName: 'Add', style: { color: '#106ebe' } }}
                menuProps={{
                  items: [
                    {
                      key: 'RECEIPT-TAXINVOICE',
                      text: t('stripe.receipt-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('RECEIPT-TAXINVOICE', item);
                      },
                    },
                    {
                      key: 'RECEIPT-TAXINVOICE-ABB',
                      text: t('stripe.receipt-taxinvoice-abb'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('RECEIPT-TAXINVOICE-ABB', item);
                      },
                    },
                    {
                      key: 'RECEIPT',
                      text: t('stripe.receipt'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('RECEIPT', item);
                      },
                    },
                    {
                      key: 'INVOICE-TAXINVOICE',
                      text: t('stripe.invoice-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('INVOICE-TAXINVOICE', item);
                      },
                    },
                    {
                      key: 'DELIVERYORDER-TAXINVOICE',
                      text: t('stripe.deliveryorder-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('DELIVERYORDER-TAXINVOICE', item);
                      },
                    },
                    {
                      key: 'TAXINVOICE',
                      text: t('stripe.taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: () => {
                        createDocument('TAXINVOICE', item);
                      },
                    },
                  ],
                  shouldFocusOnMount: true,
                  directionalHintFixed: true,
                }}
                // Optional callback to customize menu rendering
                menuAs={(props) => <ContextualMenu {...props} />}
              />
            </span>
          );
        }
      },
    },
  ];

  const disconnect = (_confirm) => {
    let confirm = _confirm;

    if (confirm) {
      setIsLoading(true);

      instance.acquireTokenSilent({ ...silentRequest, account: account }).then(
        (tokenResponse) => {
          axios
            .patch(
              API_URL + '/sources',
              {
                source: 'stripe',
                replace: '/disabled',
                value: true,
              },
              {
                headers: {
                  Authorization: 'Bearer ' + tokenResponse.accessToken,
                },
              }
            )
            .then((response) => {
              console.log(response);

              history.push({
                pathname: '/etax/sources/stripe/connect',
                state: {},
              });

              setIsLoading(false);
            })
            .catch((error) => {
              //Acquire token silent failure, and send an interactive request
              console.log(error);
              instance.acquireTokenRedirect(silentRequest);
            });
        },
        (error) => {
          console.log(error);
        }
      );
    }
  };

  const createSelectedDocuments = async (documentType) => {
    let _selectionItems = selection.getItems();

    let postUrl = '';

    switch (documentType) {
      case 'RECEIPT-TAXINVOICE':
        postUrl = API_URL + '/etax/documents/receipts-taxinvoices/pdf-xml';
        break;
      case 'RECEIPT-TAXINVOICE-ABB':
        postUrl = API_URL + '/etax/documents/receipts-taxinvoices-abb/pdf';
        break;
      case 'RECEIPT':
        postUrl = API_URL + '/etax/documents/receipts/pdf-xml';
        break;
      case 'INVOICE-TAXINVOICE':
        postUrl = API_URL + '/etax/documents/invoices-taxinvoices/pdf-xml';
        break;
      case 'DELIVERYORDER-TAXINVOICE':
        postUrl = API_URL + '/etax/documents/deliveryorders-taxinvoices/pdf-xml';
        break;
      case 'TAXINVOICE':
        postUrl = API_URL + '/etax/documents/taxinvoices/pdf-xml';
        break;
      default:
        break;
    }

    if (postUrl) {
      await instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then(async (tokenResponse) => {
          for (let i = 0; i < selectedItems.length; i++) {
            console.log('create selected document: ', selectedItems[i]);

            for (let j = 0; j < _selectionItems.length; j++) {
              if (_selectionItems[j].key === selectedItems[i].key) {
                console.log('item key: ', _selectionItems[j].key);
                _selectionItems[j].status = 'processing';

                console.log('items: ', _selectionItems);
                setItems([..._selectionItems]);

                let _date = new Date(selectedItems[i].documentDateValue);

                let _dateBE =
                  `${_date.getDate()}`.padStart(2, '0') + '/' + `${_date.getMonth() + 1}`.padStart(2, '0') + '/' + (_date.getFullYear() + 543);
                let _dateCE = `${_date.getDate()}`.padStart(2, '0') + '/' + `${_date.getMonth() + 1}`.padStart(2, '0') + '/' + _date.getFullYear();

                let _customer = {
                  addressLineOne: selectedItems[i].addressLineOne,
                  addressLineTwo: selectedItems[i].addressLineTwo,
                  branchNumber: selectedItems[i].branchNumber,
                  branchText: selectedItems[i].branchText,
                  email: selectedItems[i].customerEmail,
                  name: selectedItems[i].customerName,
                  phone: selectedItems[i].customerPhone,
                  phoneCountryCode: '+66',
                  postcode: selectedItems[i].postcode,
                  taxId: selectedItems[i].taxId,
                  taxNumberType: selectedItems[i].taxNumberType,
                  language: 'th',
                  unstructure: true,
                };

                let _vatPriceTotal = 0;
                let _zeroVatPriceTotal = 0;
                let _nonVatPriceTotal = 0;

                selectedItems[i].items.forEach((item) => {
                  if (item.percentVat === percentVat) {
                    _vatPriceTotal = _vatPriceTotal + item.total;
                  } else if (item.percentVat === zeroVat) {
                    _zeroVatPriceTotal = _zeroVatPriceTotal + item.total;
                  }
                });

                const promise_PDF_XML = await new Promise(async (resolve) => {
                  await axios
                    .post(
                      postUrl,
                      {
                        amountTotal: selectedItems[i].amountTotal,
                        company: {
                          ...company,
                          includeVat: selectedItems[i].includeVat,
                        },
                        customer: _customer,
                        date: _date,
                        dateBE: _dateBE,
                        dateCE: _dateCE,
                        discount: selectedItems[i].discount,
                        grandTotal: selectedItems[i].grandTotal,
                        items: selectedItems[i].items,
                        reference: '',
                        note: '',
                        number: selectedItems[i].number,
                        percentVat: registerVat ? percentVat : 0,
                        vatTotal: selectedItems[i].vatTotal,
                        reIssue: false,
                        includeVat: selectedItems[i].includeVat,
                        nonVatPriceTotal: _nonVatPriceTotal,
                        zeroVatPriceTotal: _zeroVatPriceTotal,
                        vatPriceTotal: _vatPriceTotal,
                        receivedBy: createdBy,
                        createdBy: createdBy,
                      },
                      {
                        headers: {
                          Authorization: 'Bearer ' + tokenResponse.accessToken,
                        },
                      }
                    )
                    .then(
                      async (response) => {
                        console.log('Create document response: ', response);

                        let count = 0;

                        let interval = await setInterval(async () => {
                          await axios
                            .get(`${API_URL}/etax/jobs/${response.data.id}`, {
                              headers: {
                                Authorization: 'Bearer ' + tokenResponse.accessToken,
                                'Content-Type': 'application/json',
                              },
                            })
                            .then((jobsResponse) => {
                              count += 1;
                              console.log('Jobs response: ', j, jobsResponse.data.status, count);

                              if (jobsResponse.data.status === 'complete') {
                                _selectionItems[j].status = 'successful';
                                _selectionItems[j].etaxCreated = true;

                                setItems([..._selectionItems]);

                                clearInterval(interval);

                                resolve(true);
                              } else if (count === 300) {
                                _selectionItems[j].status = 'fail';

                                setItems([..._selectionItems]);

                                clearInterval(interval);

                                resolve(false);
                              }
                            });
                        }, 1000);
                      },
                      (error) => {
                        console.log('Error Create document response: ', error);
                        _selectionItems[j].status = 'fail';
                        setItems([..._selectionItems]);
                        resolve(false);
                      }
                    );
                }); //promise

                Promise.all([promise_PDF_XML]).then((value) => {
                  console.log(i, value);
                });
              } //if
            } //for j
          } //for i
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });

      setIsCreateDocumentComplete(true);
      setIsCreateDocument(false);
    }

    setIsCreateDocumentComplete(true);
    setIsCreateDocument(false);
  };

  return (
    <div style={homeStyles}>
      {!isLoading && (
        <div>
          <Stack>
            <center>
              <h2 style={{ marginLeft: '0px', marginTop: '25px' }}>{t('stripe.header')}</h2>
              {!loadDataComplete && (
                <div>
                  <Spinner
                    label={t('stripe.loading')}
                    labelPosition="right"
                    style={{
                      marginTop: '21px',
                      marginBottom: '2px',
                    }}
                  />
                  <br />
                </div>
              )}
            </center>
          </Stack>

          {(selectedItems.length > 0 || isCreateDocument || isCreateDocumentComplete) && (
            <Stack vertical tokens={{ childrenGap: '10px' }}>
              <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: '10px' }}>
                <TextField
                  name="createdBy"
                  label={t('stripe.createdBy')}
                  description={t('stripe.createdByDesc')}
                  styles={{ root: { width: 200 } }}
                  onChange={(e) => {
                    setCreatedBy(e.target.value);
                  }}
                  value={createdBy}
                  disabled={isCreateDocument}
                />
              </Stack>
              <br />
            </Stack>
          )}

          {selectedItems.length > 0 && !isCreateDocument && (
            <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: '10px' }}>
              <PrimaryButton
                text={t('stripe.createDocument')}
                iconProps={{ iconName: 'Add' }}
                menuProps={{
                  items: [
                    {
                      key: 'RECEIPT-TAXINVOICE',
                      text: t('stripe.receipt-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('RECEIPT-TAXINVOICE');
                      },
                    },
                    {
                      key: 'RECEIPT-TAXINVOICE-ABB',
                      text: t('stripe.receipt-taxinvoice-abb'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('RECEIPT-TAXINVOICE-ABB');
                      },
                    },
                    {
                      key: 'RECEIPT',
                      text: t('stripe.receipt'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('RECEIPT');
                      },
                    },
                    {
                      key: 'INVOICE-TAXINVOICE',
                      text: t('stripe.invoice-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('INVOICE-TAXINVOICE');
                      },
                    },
                    {
                      key: 'DELIVERYORDER-TAXINVOICE',
                      text: t('stripe.deliveryorder-taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('DELIVERYORDER-TAXINVOICE');
                      },
                    },
                    {
                      key: 'TAXINVOICE',
                      text: t('stripe.taxinvoice'),
                      iconProps: { iconName: 'PageAdd' },
                      onClick: async (event) => {
                        setIsCreateDocument(true);
                        await createSelectedDocuments('TAXINVOICE');
                      },
                    },
                  ],
                  shouldFocusOnMount: true,
                  directionalHintFixed: true,
                }}
                // Optional callback to customize menu rendering
                menuAs={(props) => <ContextualMenu {...props} />}
              />
              <DefaultButton
                text={t('stripe.cancel')}
                style={{ marginLeft: '10px' }}
                onClick={() => {
                  let _items = selection.getItems();
                  let _selectedItems = selection.getSelection();
                  console.log('selection: ', selection.getSelection());

                  for (let i = 0; i < _selectedItems.length; i++) {
                    console.log('select item key: ', _selectedItems[i].key);
                    _selectedItems[i].status = '';

                    for (let j = 0; j < _items.length; j++) {
                      if (_items[j].key === _selectedItems[i].key) {
                        console.log('item key: ', _items[j].key);
                        _items[j].status = '';
                        _selectedItems[i].status = '';
                      }
                    }
                  }

                  selection.setAllSelected(false);

                  setItems(_items);
                  console.log('selection: ', selection.getSelection());
                }}
              />
              <br />
            </Stack>
          )}

          {isCreateDocument && (
            <div>
              <Spinner label={t('stripe.signProcessing')} size={SpinnerSize.large} />
            </div>
          )}

          {isCreateDocumentComplete && (
            <center>
              <PrimaryButton
                text={t('stripe.createdDocuments')}
                iconProps={{ iconName: 'Documentation' }}
                onClick={async () => {
                  console.log(selectedItems);
                  history.push({
                    pathname: '/etax/documents/all',
                    state: {},
                  });
                }}
              />
            </center>
          )}

          <br />

          <Stack horizontal horizontalAlign="center">
            <Stack
              vertical
              style={{
                width: '98%',
                minWidth: '800px',
                maxWidth: '1350px',
              }}
            >
              <Stack 
                horizontal 
                styles={{
                  root: {
                    backgroundColor: 'white',
                  },
                }}
                horizontalAlign="space-between"
              >
                <CommandBar
                  items={commandBarItems}
                  overflowItems={overflowItems}
                  styles={{
                    root: {
                      width: 'calc(100vw - 700px)',
                      minWidth: '700px',
                      maxWidth: '900px',
                    },
                  }}
                />
                <Stack
                  horizontal
                  styles={{
                    root: {
                      height: 44,
                    },
                  }}
                  tokens={{ childrenGap: '10px' }}
                >
                  <SearchBox
                    className="ms-borderColor-themePrimary"
                    styles={{
                      root: {
                        marginTop: 6,
                        width: 270,
                        fontSize: 13,
                        fontWeight: 0,
                      },
                    }}
                    disabled={!loadDataComplete}
                    placeholder={t('stripe.searchBoxPlaceholder')}
                    onChange={(e) => {
                      setSearch(e ? e.target.value : '');
                    }}
                    onClear={() => {
                      setLoadDataComplete(false);
                      setItems([]);
                      setGetNewDocuments(true);

                      setCurrentPage(1);
                    }}
                    onSearch={() => {
                      setLoadDataComplete(false);
                      setItems([]);
                      setGetNewDocuments(true);

                      setCurrentPage(1);
                    }}
                    value={search}
                  />
                  <PrimaryButton
                    disabled={!loadDataComplete || !search}
                    styles={{
                      root: {
                        marginTop: 6,
                        marginRight: 18,
                        width: 90,
                      },
                    }}
                    text={t('stripe.search')}
                    onClick={() => {
                      setLoadDataComplete(false);
                      setItems([]);
                      setGetNewDocuments(true);

                      setCurrentPage(1);
                    }}
                  />
                </Stack>
              </Stack>
              <ShimmeredDetailsList
                items={items || []}
                enableShimmer={!loadDataComplete}
                compact={isCompactMode}
                columns={columns}
                selection={selection}
                selectionMode={!loadDataComplete || isCreateDocument ? SelectionMode.none : SelectionMode.multiple}
                layoutMode={DetailsListLayoutMode.justified}
                isHeaderVisible={true}
                checkboxVisibility={CheckboxVisibility.always}
                selectionPreservedOnEmptyClick={true}
              />
            </Stack>
          </Stack>
          <br />
          <center>
            {!(currentPage === 1 && items.length < pageSize) && !(!loadDataComplete || isCreateDocument) && (
              <Pagination
                selectedPageIndex={currentPage - 1}
                pageCount={pageData.totalPages}
                onPageChange={onPageChange}
                format
                firstPageIconProps={{
                  iconName: 'DoubleChevronLeft',
                }}
                previousPageIconProps={{
                  iconName: 'ChevronLeft',
                }}
                nextPageIconProps={{
                  iconName: 'ChevronRight',
                }}
                lastPageIconProps={{
                  iconName: 'DoubleChevronRight',
                }}
              />
            )}

            <br />
            <br />
          </center>
        </div>
      )}

      {isLoading && (
        <div>
          <Stack>
            <center>
              <h2
                style={{
                  marginLeft: '0px',
                  marginTop: '25px',
                  marginBottom: '50px',
                }}
              >
                {t('stripe.footer')}
              </h2>
            </center>
            <Stack horizontal horizontalAlign="center">
              <br />
              <br />
              <div>
                <Spinner label={t('stripe.processing2')} labelPosition="down" styles={spinnerStyles} />
              </div>
              <br />
            </Stack>
          </Stack>
        </div>
      )}
      <Dialog
        hidden={!dialogConfirm.isClick}
        onDismiss={dialogConfirm.onCancel}
        styles={{ main: { minHeight: 0 } }}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: dialogConfirm.header,
          styles: { header: { textAlign: 'center' }, title: { paddingRight: 24 }, subText: { textAlign: 'center' } },
          subText: dialogConfirm.message,
        }}
      >
        <DialogFooter styles={{ actionsRight: { textAlign: 'center' } }}>
          <PrimaryButton onClick={dialogConfirm.onConfirm} text={t('documents.confirm')} />
          <DefaultButton onClick={dialogConfirm.onCancel} text={t('documents.cancel')} />
        </DialogFooter>
      </Dialog>
    </div>
  );
};

export default Stripe;
